export const newGoodReq = {
  listAdd: 'n.213.1023.0',
  nameSuggest: 'n.214.1025.0',
  brandSuggest: 'n.214.1026.0',
  toSsu: 'n.239.1156.0'
}
